/**
 * 监控服务器运行
 * @author： xuyd
 * @date：2022-01-12
 */
import request from "@/utils/request.js"

import {context} from '@/config/env.js'
import {download} from "../../utils/request";

const serviceModule = context.sunflower

export default {

  /**
   * 列表检索
   * @param params
   */
  searchMonitorServerList: (params) => {
    return request.post(serviceModule + "/monitor/channel/searchChannelList", params);
  },

  /**
   * task列表检索
   * @param params
   */
  searchMonitorTaskList: (params) => {
    return request.post(serviceModule + "/monitor/channel/searchTaskList", params);
  },

  /**
   * 导出
   * @param params
   */
  exportTaskList: (params) => {
    return request.download(serviceModule + "/monitor/channel/exportTaskList", params);
  },

  /**
   * 查询
   * @param id
   */
  queryMonitorInfo: (id) => {
    return request.get(serviceModule + "/monitor/channel/queryChannelInfo?id=" + id);
  },

  /**
   * 保存
   * @param params
   */
  saveMonitorServer: (params) => {
    return request.post(serviceModule + "/monitor/channel/saveChannelInfo", params);
  },

  /**
   * 删除
   * @param id
   */
  deleteMonitorServer: (id) => {
    return request.post(serviceModule + "/monitor/channel/deleteChannelInfo?id=" + id);
  },

  /**
   * 连通性测试
   * @param params
   */
  validateConn: (params) => {
    return request.post(serviceModule + "/monitor/channel/validateConn", params);
  },

  /**
   * 订阅监控刷新
   * 【暂不走验证】
   * @param clientId
   */
  subscribeMonitorMessage: (clientId) => {
    return request['sseEventSource'](serviceModule + `/openapi/sse/monitor/subscribeMessage/${clientId}`);
  },

}
